import * as React from "react";
import { ErrorBoundary } from "react-error-boundary";
import Error from "../components/error";

interface WithErrorHandlingProps {
  children?: React.ReactNode | React.ReactNode[];
}

const WithErrorHandling = ({ children }: WithErrorHandlingProps) => (
  <ErrorBoundary FallbackComponent={Error}>{children}</ErrorBoundary>
);
export default WithErrorHandling;
